import { createStyles, makeStyles } from '@material-ui/styles';
import palette from '../../../../theme/palette';

const style = () =>
  createStyles({
    root: {
      background: palette.background.lightblue,
      borderRadius: palette.borderRadius.default,
      boxShadow: palette.shadows.buttonShadow,
      fontWeight: 600,
      color: palette.text.white,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-start',
      position: 'relative',
      overflow: 'hidden',
      zIndex: 0,
      gap: '10px',
      padding: '10px 20px',
      cursor: 'pointer',
      fontSize: '1.5rem',
      transition: '0.3s ease',
      transform: 'scale(1)',
      '&:hover': {
        transform: 'scale(1.05)'
      }
    }
  });

const useStyle = makeStyles(style);
export default useStyle;
